const BLOB_END_POINT = 'https://nsbs-ast-tru-sa-prod-cgcaehavedg3ceg3.z01.azurefd.net';
// SAS token
const SHARED_ACCESS_SIGNATURE = 'sp=racwdl&st=2026-07-30T07:26:53Z&se=2028-08-01T15:41:53Z&sv=2026-02-06&sr=c&sig=1mKmwQOq%2FQmeaLK%2FPYViZg1AQWqodYOKuNYXaICG%2BNM%3D';

const BLOB_SERVICE_CLIENT_URL = `${BLOB_END_POINT}?${SHARED_ACCESS_SIGNATURE}`;

const CONTAINER_NAME = 'storage-prod'

const STORAGE_NAME = 'rbptrueblue';

const PIPELINE_APP_VERSION = '20261028.1';

export const AZURE_CONFIG = {
  PIPELINE_APP_VERSION,
  BLOB_END_POINT,
  SHARED_ACCESS_SIGNATURE,
  BLOB_SERVICE_CLIENT_URL,
  CONTAINER_NAME,
  STORAGE_NAME
}